import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarImageEditIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        className="Icon toolbar-image-edit"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                className="decoration"
                fill="none"
                stroke="#48505E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M6.833 15.083h7.15c1.62 0 2.934 1.314 2.934 2.934v7.15m2.75-2.75h-7.15a2.934 2.934 0 0 1-2.934-2.934v-7.15M23.5 16v-3.667a2.917 2.917 0 0 0-2.917-2.916h-3.666m2.291-3.042-2.291 2.292 2.291 2.292"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarImageEditIcon);
export default Memo;
